import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Modal from 'react-bootstrap-modal'
import { translate } from 'react-i18next'

import NotesComponent from './NotesComponent'
import { graphql, compose } from 'react-apollo'
import { Snackbar } from 'material-ui'
import { NotificationManager } from 'react-notifications'

import ADD_NOTE_QUERY from './../../graphql/Note/AddNote.graphql'

class AddNotesModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    event: PropTypes.object,
    currentDay: PropTypes.number,
    user: PropTypes.object
  }
  constructor(props) {
    super(props)
    this.state = {
      openNotification: false
    }
  }

  handleTouchTapNotification = () => {
    this.setState({
      openNotification: true
    })
  }

  onSubmit(data) {
    this.props
      .updateNote({
        variables: {
          ...data,
          defaultPhotoId: data.defaultPhoto ? data.defaultPhoto.id : null,
          userId: this.props.user.id
        }
      })
      .then(success => {
        this.handleTouchTapNotification()
        this.props.onClose()
      })
      .catch(err => {
        NotificationManager.error(err.message, 'Error', 5000)
      })
  }
  render() {
    const { isOpen, onClose } = this.props

    return (
      <Modal show={isOpen} onHide={() => onClose()} dialogClassName="event-modal" aria-labelledby="ModalHeader">
        <Modal.Body>
          <NotesComponent
            t={this.props.t}
            user={this.props.user}
            onSubmit={data => {
              this.onSubmit(data)
            }}
          />
          <i className="event-modal__close icon-close" onClick={() => onClose()} />
          <Snackbar
            open={this.state.openNotification}
            message="POI Created"
            autoHideDuration={2000}
            onRequestClose={this.handleRequestClose}
          />
        </Modal.Body>
      </Modal>
    )
  }
}

const enhance = compose(
  translate('add_notes'),
  graphql(ADD_NOTE_QUERY, {
    name: 'updateNote',
    options: props => ({
      fetchPolicy: 'no-cache'
    })
  })
)
export default enhance(AddNotesModal)



// WEBPACK FOOTER //
// src/components/Notes/AddNotesModal.js